export default __webpack_public_path__ + "static/pragicts-secops-services-ransomware-security-43c36657a1a95a3bed5a1ae0f4ca0b7f.jpg";